import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getFormSyncErrors } from "redux-form";
import _ from "lodash";
import toast from "react-hot-toast";
import { manageTicketCount, applyPromo, cancelPromo } from "@ticketsaction";
import { SITE_URL } from "@constant";
import {
  classNames,
  priceDisplayLocally,
  getTaxDetails,
  validateEmail,
} from "@utilscommon";
import Stripe from "@stripepay";
import Paypal from "@paypalpay";
import Razorpay from "@razorpaypay";
import LocaleStrings from "@language";

const eventIgnoreDev = [1809168258022604, 1796105987495950, 1791940621293163]; // These dev event we need to ignore with new strip fee calculation. Once These events are completed then remove this
const eventIgnoreApp = [
  1804004828003810, 1802718411079660, 1791443559707490, 1814259710138170,
  1812028853942120, 1813913402399000, 1809210399418170, 1813268017344940,
  1816530335218080, 1810011661369050, 1804418708001680, 1797191152501470,
  1795494028893460, 1815732504889410, 1816488111770050, 1802850225652260,
  1812999892710280, 1810648289261520, 1812290540763660, 1807211304751440,
  1811395936484930, 1810523648265260, 1813256182878770, 1799567323168040,
  1809836911042670, 1815716368288140, 1814477176238730, 1815446498786970,
]; // These app event we need to ignore with new strip fee calculation. Once These events are completed then remove this
const eventIgnore =
  SITE_URL === "dev.eventify.io" ? eventIgnoreDev : eventIgnoreApp;

const TicketOrderDetails = (props) => {
  const {
    // Parent Props
    selectedCurrency,
    currentStep,
    ticketNav,
    eventifyFee,
    stripeFee,
    stripeFixedFee,
    callFrom,
    prepromo,
    btnLoading,
    orderAction,
    pristine,
    invalid,
    submitting,
    formValues,
    onlinePaymentKeys,

    // Own Props
    session,
    eventData,
    eventSettingsData,
    manageTicketsCount,
    promoApplied,
    stripeConnection,
    assignedAttendeeTickets,
    assignedAttendeeErrors,
    promodata,
    promoAppliedRemoved,
    ticketArray,
  } = props;
  const promoRef = useRef();
  const [applyPrePromo, setApplyPrePromo] = useState(false);
  const [allowPromo, setAllowPromo] = useState(false);
  const [promoButtonLoading, setPromoButtonLoading] = useState(false);
  const [promoErrorMessage, setPromoErrorMessage] = useState("");
  const { hide_additional_charges: hideAdditionalCharges = false } = JSON.parse(
    eventSettingsData?.data?.custom_settings ?? "{}"
  );
  // console.log("eventData :- ", eventData);
  // console.log("eventSettingsData :- ", eventSettingsData);
  // console.log("onlinePaymentKeys :- ", onlinePaymentKeys);
  // console.log("manageTicketsCount :- ", manageTicketsCount);
  // console.log("assignedAttendeeTickets :- ", assignedAttendeeTickets);
  // console.log("assignedAttendeeErrors :- ", assignedAttendeeErrors);
  // console.log("promoApplied :- ", promoApplied);
  // console.log(currentStep);
  // console.log(ticketNav?.flow);

  let totalNavs = ticketNav?.flow?.length;
  // Logic to get next nav
  let index = _.findIndex(ticketNav?.flow, (o) => {
    return o.key === currentStep;
  });
  // console.log("index :- ", index);
  let nextIndex = index >= 0 ? index + 1 : 1;
  let lastIndex = _.lastIndexOf(ticketNav?.flow);
  // console.log("lastIndex :- ", lastIndex);
  nextIndex = nextIndex > lastIndex ? lastIndex : nextIndex;
  // console.log("nextIndex :- ", nextIndex);
  let nextNav = ticketNav?.flow?.[nextIndex];
  // console.log("nextNav :- ", nextNav);
  let billingAccountInfo = eventData?.platform_billing_account
    ? JSON.parse(eventData.platform_billing_account)
    : { stripe: "AU" };
  // console.log("billingAccountInfo :- ", billingAccountInfo);

  const handlePerPromo = () => {
    setApplyPrePromo(true);

    handlePromoApply(prepromo);
  };

  const handlePromoApply = (code = "") => {
    let promo = "";
    if (code !== "") {
      promo = code;
    } else {
      promo = promoRef.current.value;
    }
    // console.log("promo :- ", promo);

    let tickets = [];
    let ticketTotalPrice = 0;
    _.map(manageTicketsCount, (item) => {
      let obj = {
        ticketid: item.ticketid,
        quantity: item.quantity,
        price: item.price,
      };
      tickets.push(obj);

      let ticketprice = item?.quantity * item?.price;
      ticketTotalPrice = ticketTotalPrice + ticketprice;
    });

    setPromoErrorMessage("");
    if (promo !== "") {
      if (ticketTotalPrice > 0) {
        let values = {
          eventid: eventData?.eventid,
          promo: promo,
          tickets: tickets,
        };
        if (validateEmail(formValues?.email?.trim() ?? "")) {
          values.buyeremail = formValues.email.trim();
        }

        setPromoButtonLoading(true);
        props.applyPromo(session, values, (response) => {
          // console.log("response :- ", response);
          setPromoButtonLoading(false);
          setApplyPrePromo(false);
          if (response.success === 1) {
            // Promo applicable
            setAllowPromo(false);
          } else if (response.success === 2) {
            if (response?.data?.code === "eventid_required") {
              toast.error(LocaleStrings.kEventidRequiredText);
            } else if (response?.data?.code === "promo_required") {
              toast.error(LocaleStrings.kPromoRequiredText);
            } else if (response?.data?.code === "invalid_tickets") {
              toast.error(LocaleStrings.kInvalidTicketDataText);
            } else if (response?.data?.code === "invalid_promocode") {
              toast.error(LocaleStrings.kInvalidPromoText);
            } else if (response?.data?.code === "promo_not_applicable") {
              toast.error(LocaleStrings.kPromoNotApplyOnSelectedTicketsText);
            } else if (response?.data?.code === "promo_limit_exceeded") {
              toast.error(LocaleStrings.kPromoLimitExceededText);
            } else if (response?.data?.code === "promo_expired") {
              toast.error(LocaleStrings.kPromoExpiredText);
            } else if (response?.data?.code === "promo_amount_greater") {
              toast.error(
                LocaleStrings.kPromoAmountGreaterThanTicketAmountText
              );
            } else if (
              response?.data?.code === "enter_email_for_promo_access"
            ) {
              setPromoErrorMessage(
                LocaleStrings.kPrePromoSpecificBuyerAccessInfoText
              );
            } else if (
              response?.data?.code === "promo_not_applicable_for_buyer"
            ) {
              setPromoErrorMessage(
                LocaleStrings.kPromoNotApplicableForBuyerText
              );
            } else {
              toast.error(LocaleStrings.kSomethingWentWrongMsg);
            }
          } else {
            toast.error(LocaleStrings.kSomethingWentWrongMsg);
          }
        });
      } else {
        toast.error(LocaleStrings.kPromoNotApplyOnFreeTicketsText);
      }
    } else {
      toast.error(LocaleStrings.kPromoRequiredText);
    }
  };

  const removePromo = () => {
    if (prepromo && prepromo !== "") {
      // true param is sending for pre applied promo, only sending if user removed promo manually
      props.cancelPromo({}, true);
    } else {
      props.cancelPromo({});
    }
  };

  const handleContinue = () => {
    if (currentStep === "assignment") {
      // Here check if all ticket attendee is assigned or not
      let invalidData = [];
      let errorData = [];
      _.forEach(manageTicketsCount, (obj) => {
        let ticketid = obj?.ticketid;
        let qty = obj?.noofchildtickets ? obj?.noofchildtickets : obj?.quantity;
        let minattendees = obj?.minattendees ? obj.minattendees : null;

        if (assignedAttendeeTickets?.[ticketid]?.length === qty) {
          // Ok
        } else {
          invalidData.push(obj);
        }

        if (assignedAttendeeErrors?.[ticketid]) {
          _.forEach(assignedAttendeeErrors?.[ticketid], (o) => {
            if (!_.isEmpty(o)) {
              // find the array having none empty object of assignedAttendeeErrors
              const filteredArr = assignedAttendeeErrors?.[ticketid].filter(
                (obj) => Object.keys(obj).length > 0
              );
              // console.log({ filteredArr });
              // check the minattendees is not null menas for childgroup tickets and filled array is greter than min attnedees
              if (minattendees && filteredArr.length > minattendees) {
                // check all the others firstname lastname email is empty otherwise through error to fill full form
                const hasMissingFields = filteredArr.some(
                  (user) => !user.firstname || !user.lastname || !user.email
                );
                if (hasMissingFields) {
                  errorData.push(o);
                }
              } else {
                errorData.push(o);
              }
            }
          });
        }
      });
      // console.log("invalidData :- ", invalidData);
      // console.log("errorData :- ", errorData);

      if (invalidData?.length > 0) {
        toast.error(LocaleStrings.kFillAllAttendeeDetailsText);
      } else {
        props.updateFormHasError(false);
        if (errorData?.length > 0) {
          // Form error
          setTimeout(() => {
            props.updateFormHasError(true);
          }, 200);
        } else {
          props.updateNav(nextNav?.key ?? "ticket");
        }
      }
    } else {
      props.updateNav(nextNav?.key ?? "ticket");
    }
  };

  const handleTicketOrder = (total, action) => {
    let data = { ...formValues };
    data.amount = total.toFixed(2);
    data.promocode = _.isEmpty(promoApplied) ? "" : promoApplied?.promocode;
    data.currency = action === "freepayment" ? "" : selectedCurrency;
    data.type = action;
    if (action === "freepayment") {
      data.paymenttype = "free";
    }
    if (action === "cash" || action === "withoutpay") {
      data.type = "freepayment";
      data.paymenttype = action;
    }

    // console.log(
    //   "total :- ",
    //   data,
    //   promoApplied,
    //   selectedCurrency,
    //   total,
    //   action
    // );

    props.formSubmit(data);
  };

  const renderTicketsOrder = () => {
    let returnHtml = [];
    let allValid = true;
    let ticketOwnTax = false; // Check if ticket has own tax or not
    let subTotal = 0;
    let promoApplyTo = []; // Discount related
    let couponType = ""; // Discount related
    let usagesType = ""; // Discount related
    let discountRate = ""; // Discount related
    let discountAmount = 0; // Discount related
    let globalTaxName = eventSettingsData?.data?.taxname ?? ""; // Global Tax related
    let globalTaxRate = eventSettingsData?.data?.tax ?? ""; // Global Tax related
    let taxAmount = 0; // Tax related
    let feeAmount = 0; // Fee related
    let passonTicketArray = []; // Fee related
    let totalAmount = 0;
    let paylaterTotalAmount = 0;
    let selectedTicketDetails = { free: 0, paid: 0 };
    // Tracking promo application
    let promoTicketLimit = 0;
    let ticketEligibilityMap = {};
    let buyerCountry =
      formValues?.country && formValues?.country !== ""
        ? formValues?.country
        : ticketArray?.country ?? "";
    let otherprops = { billingaccount: billingAccountInfo };

    const calculatePromoEligibility = (tickets, promoLimit) => {
      let eligibilityMap = {};
      let appliedCount = 0;

      _.forEach(tickets, (ticket) => {
        const ticketId = ticket.ticketid;
        const qty = ticket.quantity;
        if (ticket.price > 0) {
          if (appliedCount < promoLimit) {
            const eligibleQty = Math.min(qty, promoLimit - appliedCount);
            eligibilityMap[ticketId] = eligibleQty;
            appliedCount += eligibleQty;
          } else {
            eligibilityMap[ticketId] = 0;
          }
        }
      });

      return eligibilityMap;
    };

    // Helper function to check if a promo applies to a specific ticket
    const isDiscountApplicable = (ticketId) => {
      if (promoApplyTo.length > 0) {
        const promoApplyTickets = _.map(promoApplyTo, (o) =>
          parseInt(o.ticketid)
        );
        return _.includes(promoApplyTickets, ticketId);
      }
      return true; // If no specific tickets mentioned, applies to all
    };

    // Helper function to calculate discount amount for a specific ticket
    const calculateTicketDiscount = (ticketId, price, totalPaid) => {
      const isPaid = price > 0;
      if ((discountAmount <= 0 || !isDiscountApplicable(ticketId)) && !isPaid) {
        return 0;
      }

      // Get the eligible quantity from our map (respects ticket limit)
      const eligibleQty = ticketEligibilityMap[ticketId] || 0;
      if (eligibleQty <= 0) return 0;

      const eligiblePrice = price * eligibleQty;

      if (couponType === "percentage") {
        // Percentage discount is the same for both usage types in the original code
        return (eligiblePrice * discountRate) / 100;
      } else {
        if (usagesType === "perorder") {
          // Discount on total order amount, distributed by quantity
          return (discountRate / totalPaid) * eligibleQty;
        } else {
          // Discount on per ticket amount
          return discountRate * eligibleQty;
        }
      }
    };

    _.forEach(manageTicketsCount, (item, index) => {
      let ticketname = item?.name;
      let qty = item?.quantity;
      let price = item?.price;
      let feesetting = item?.feesetting;
      let taxname = item?.taxname ?? "";
      let taxrate = item?.tax ?? "";
      if (item?.invalid) {
        allValid = false;
      }
      if (taxname !== "" && taxrate !== "" && taxrate > 0) {
        ticketOwnTax = true;
      }

      let ticketprice = qty * price;
      subTotal = subTotal + ticketprice;

      if (price > 0) {
        selectedTicketDetails.paid = selectedTicketDetails.paid + qty;
      } else {
        selectedTicketDetails.free = selectedTicketDetails.free + qty;
      }

      // Calculating other fees first part
      if (feesetting === "passon") {
        passonTicketArray.push(item);
      }
      // console.log("passonTicketArray :- ", passonTicketArray);

      returnHtml.push(
        <div
          key={`order_${index}`}
          className="flex items-center justify-between custom-text-primary-md-normal"
        >
          <div>
            {qty} * {ticketname}
          </div>
          <div>{priceDisplayLocally(ticketprice)}</div>
        </div>
      );
    });

    // Check if selected all tickets have pay later option or not. if selected tickets are like below, then follow below criteria
    // offline => offline
    // online => online
    // both(online & offline) => both
    // offline + online => offline
    // offline + both(online & offline) => offline
    // online + both(online & offline) => online
    // offline + online + both(online & offline)  => offline
    // console.log("manageTicketsCount :- ", manageTicketsCount);

    let showOptions = "";
    let allPaidTickets = _.filter(manageTicketsCount, (o) => o.price > 0);
    if (allPaidTickets.length === 1) {
      let paymentmode = allPaidTickets[0].isofflinepayment;
      // console.log("paymentmode :- ", paymentmode);

      showOptions =
        paymentmode === 0 ? "online" : paymentmode === 1 ? "offline" : "both";
    } else if (allPaidTickets.length > 1) {
      let pOffline = _.filter(allPaidTickets, (o) => o.isofflinepayment === 1);
      if (pOffline.length > 0) {
        showOptions = "offline";
      } else {
        let pOnline = _.filter(allPaidTickets, (o) => o.isofflinepayment === 0);
        if (pOnline.length > 0) {
          showOptions = "online";
        } else {
          let pBoth = _.filter(allPaidTickets, (o) => o.isofflinepayment === 2);
          if (pBoth.length > 0) {
            showOptions = "both";
          }
        }
      }
    }

    // Script to display or not pre applied promo ui
    let displayPromo = false;
    if (!_.isEmpty(promodata)) {
      let callPromo = false;
      if (promodata.promoaccess === "all") {
        callPromo = true;
      } else {
        let promoAccessSplit = promodata.promoaccess.split(",");
        let promoAccessArray = _.map(promoAccessSplit, (o) => parseInt(o));
        let manageTicketsArray = _.map(manageTicketsCount, (o) => o.ticketid);

        // console.log("promoAccessArray :- ", promoAccessArray);
        // console.log("manageTicketsArray :- ", manageTicketsArray);
        let commonTicket = _.intersection(promoAccessArray, manageTicketsArray);
        if (commonTicket.length > 0) {
          callPromo = true;
        }
      }

      if (
        callPromo &&
        promoAppliedRemoved &&
        ((!_.isEmpty(promoApplied) && promoApplied.promocode !== prepromo) ||
          _.isEmpty(promoApplied))
      ) {
        displayPromo = true;
      }
    }

    // Push divider for sub total
    returnHtml.push(
      <div key={`divider_1`} className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-300" />
        </div>
      </div>
    );

    if (selectedTicketDetails?.paid > 0) {
      // Push sub total amount
      returnHtml.push(
        <div
          key={`subtotal`}
          className="flex items-center justify-between custom-text-secondary-md-normal"
        >
          <div>{LocaleStrings.kSubtotal}</div>
          <div>{priceDisplayLocally(subTotal)}</div>
        </div>
      );
      totalAmount = totalAmount + subTotal;
    }

    if (
      (!hideAdditionalCharges || currentStep === "payment") &&
      selectedTicketDetails?.paid > 0
    ) {
      // Promo coode section
      if (subTotal > 0 && allValid) {
        let discountAppliedTicketNames = [];
        let promoApplyCode = ``;

        if (!_.isEmpty(promoApplied)) {
          let totalPaid = 0;
          let totalTicketPrice = 0;
          // let promoAppliedCount = 0;
          promoApplyCode = promoApplied?.promocode ?? "";
          promoApplyTo = promoApplied?.applyto ?? [];
          couponType = promoApplied?.coupontype;
          usagesType = promoApplied?.usagetype;
          discountRate = promoApplied?.discountrate;
          promoTicketLimit = promoApplied?.ticketlimit || Infinity;

          // Calculate which tickets get the promo (respecting the ticket limit)
          let targetTickets = manageTicketsCount;
          if (promoApplyTo.length > 0) {
            const promoApplyTickets = _.map(promoApplyTo, (o) =>
              parseInt(o.ticketid)
            );
            targetTickets = _.filter(manageTicketsCount, (o) =>
              _.includes(promoApplyTickets, o.ticketid)
            );
          }

          ticketEligibilityMap = calculatePromoEligibility(
            targetTickets,
            promoTicketLimit
          );

          // Calculate total paid and ticket price using eligibility map
          _.forEach(targetTickets, (ticket) => {
            const ticketId = ticket.ticketid;
            const price = ticket?.price ?? 0;

            if (price > 0) {
              const eligibleQty = ticketEligibilityMap[ticketId] || 0;
              totalPaid += eligibleQty;
              totalTicketPrice += eligibleQty * price;
            }
          });

          const eligibleTickets = _.filter(
            targetTickets,
            (ticket) =>
              (ticketEligibilityMap[ticket.ticketid] || 0) > 0 &&
              ticket.price > 0
          );

          _.forEach(eligibleTickets, (o) => {
            discountAppliedTicketNames.push({
              ticketname: o.name,
              quantity: ticketEligibilityMap[o.ticketid] || 0,
            });
          });

          if (couponType === "percentage") {
            if (usagesType === "perorder") {
              // Discount on total order amount
              discountAmount = (totalTicketPrice * discountRate) / 100;
            } else {
              // Discount on per ticket amount
              discountAmount = (totalTicketPrice * discountRate) / 100;
            }
          } else {
            if (usagesType === "perorder") {
              // Discount on total order amount
              discountAmount = discountRate;
            } else {
              // Discount on per ticket amount
              discountAmount = totalPaid * discountRate;
            }
          }
        }
        let promoParams = {
          context: "afterticket",
          promoApplyCode,
          discountAmount,
          discountAppliedTicketNames,
        };
        // console.log("discountAmount :- ", discountAmount);

        returnHtml.push(
          <div key={`promocode`} className="">
            {renderAvailablePromo(promoParams)}

            {discountAmount > 0 ? (
              <div className="flex justify-between text-theme">
                <div className="custom-text-secondary-md-normal basis-2/3">
                  {LocaleStrings.kDiscountText} ({promoApplyCode})
                </div>
                <div className="custom-text-secondary-md-normal">
                  - {priceDisplayLocally(discountAmount)}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        );
      }
      totalAmount = totalAmount - discountAmount;

      // Tax section
      if (allValid) {
        let calculateTaxAmount = 0;
        let allTaxDetails = [];

        const paidTicketDetails = _.filter(
          manageTicketsCount,
          (o) => o.price > 0
        );
        const totalPaid = _.sum(
          _.map(paidTicketDetails, (o) => ticketEligibilityMap[o.ticketid] || 0)
        );

        _.forEach(paidTicketDetails, (item) => {
          const ticketid = item?.ticketid;
          const qty = item?.quantity;
          const price = item?.price;
          const ticketprice = qty * price;

          const ticketDiscountAmount = calculateTicketDiscount(
            ticketid,
            price,
            totalPaid
          );

          const ticketPriceAfterDiscount = ticketprice - ticketDiscountAmount;

          const { taxAmount, taxDetails } = getTaxDetails(
            { ...item, price: ticketPriceAfterDiscount },
            eventSettingsData,
            buyerCountry
          );

          calculateTaxAmount += taxAmount;
          allTaxDetails = allTaxDetails.concat(taxDetails || []);
        });

        taxAmount = calculateTaxAmount;

        // Group tax details by taxName + taxRate for display
        const groupedTaxes = _.groupBy(
          allTaxDetails,
          (t) => `${t.taxName}-${t.taxRate}`
        );

        const taxDisplayLines = Object.values(groupedTaxes).map(
          (group, index) => {
            const { taxName, taxRate } = group[0];
            const totalTaxAmount = _.sumBy(group, "taxAmount");

            return (
              <div
                key={`tax-${index}`}
                className="flex items-center space-x-2 justify-between"
              >
                <div className="custom-text-secondary-md-normal basis-2/3">
                  {taxName} ({taxRate}%)
                </div>
                <div className="custom-text-secondary-md-normal">
                  + {priceDisplayLocally(totalTaxAmount)}
                </div>
              </div>
            );
          }
        );
        returnHtml.push(
          <div key={`tax-wrapper`} className="">
            {taxDisplayLines}
          </div>
        );
        totalAmount += taxAmount;
      }

      // Fee section
      let passonEventifyFee = 0;
      if (
        (showOptions !== "offline" &&
          stripeConnection?.data?.stripeaccountid) ||
        callFrom === "admin"
      ) {
        if (passonTicketArray?.length > 0 && allValid) {
          // Calculating other fees and checking if it's stripe payment or cash

          const paidTicketDetails = _.filter(
            manageTicketsCount,
            (o) => o.price > 0
          );
          const totalPaid = _.sum(
            _.map(
              paidTicketDetails,
              (o) => ticketEligibilityMap[o.ticketid] || 0
            )
          );

          let passonSubTotal = 0;
          let passonDiscount = 0;
          let passonTax = 0;

          _.forEach(passonTicketArray, (item) => {
            const ticketid = item?.ticketid;
            const taxname = item?.taxname ?? "";
            const taxrate = item?.tax ?? "";
            const qty = item?.quantity;
            const price = item?.price;
            const ticketprice = qty * price;
            let eFee = eventifyFee * qty;

            passonSubTotal += ticketprice;

            // Calculate discount for this ticket using our helper function
            const passonDiscountAmount = calculateTicketDiscount(
              ticketid,
              price,
              totalPaid
            );
            passonDiscount += passonDiscountAmount;

            // Calculate tax on the post-discount amount
            const ticketPriceAfterDiscount = ticketprice - passonDiscountAmount;
            let passonTaxAmount = 0;

            // Check if full discount, then make eventify fee for this ticket 0
            if (ticketPriceAfterDiscount === 0) {
              eFee = 0;
              passonTaxAmount = 0;
            } else {
              const { taxAmount } = getTaxDetails(
                { ...item, price: ticketPriceAfterDiscount },
                eventSettingsData,
                buyerCountry
              );
              passonTaxAmount = taxAmount;
            }

            passonTax += passonTaxAmount;
            passonEventifyFee += eFee;
          });

          let passonTicketFee = passonSubTotal - passonDiscount + passonTax;
          // console.log("passonTicketFee :- ", passonTicketFee);
          // console.log("stripeFee :- ", stripeFee);
          // console.log("stripeFixedFee :- ", stripeFixedFee);
          // console.log("passonEventifyFee :- ", passonEventifyFee);

          if (callFrom !== "admin") {
            // Calculate stripe fee charges
            let percentageInPoints = stripeFee / 100;
            let buyerPay =
              (parseFloat(passonTicketFee) +
                parseFloat(passonEventifyFee) +
                parseFloat(stripeFixedFee)) /
              (1 - percentageInPoints);
            if (_.includes(eventIgnore, parseInt(eventData?.eventid))) {
              buyerPay = parseFloat(passonTicketFee);
            }
            let stripeCharge =
              buyerPay * percentageInPoints +
              passonEventifyFee +
              stripeFixedFee;

            feeAmount = passonTicketFee > 0 ? stripeCharge : 0;
          } else {
            feeAmount = passonTicketFee > 0 ? passonEventifyFee : 0;
          }
          feeAmount = totalAmount > 0 ? feeAmount : 0; // Check if ticket amount is greated than 0 then only apply passon fee

          returnHtml.push(
            <div key={`fee`} className="">
              <div className="flex items-center space-x-2 justify-between">
                <div className="custom-text-secondary-md-normal basis-2/3">
                  {LocaleStrings.kFee}
                </div>
                <div className="custom-text-secondary-md-normal">
                  + {priceDisplayLocally(feeAmount)}
                </div>
              </div>
            </div>
          );
        }
      }
      // console.log("feeAmount :- ", feeAmount);

      paylaterTotalAmount = paylaterTotalAmount + totalAmount;
      // paylaterTotalAmount = paylaterTotalAmount + passonEventifyFee; // Not required
      totalAmount = totalAmount + feeAmount;

      // Push divider for total
      if (allValid) {
        returnHtml.push(
          <div key={`divider_2`} className="relative">
            <div
              className="absolute inset-0 flex items-center"
              aria-hidden="true"
            >
              <div className="w-full border-t border-gray-300" />
            </div>
          </div>
        );
      }

      // Push total amount
      if (allValid) {
        returnHtml.push(
          <div
            key={`totalamount`}
            className="flex items-center justify-between custom-text-primary-md-bold"
          >
            <div>{LocaleStrings.kTotal}</div>
            <div>
              {selectedCurrency} {priceDisplayLocally(totalAmount)}
            </div>
          </div>
        );
      }
    }
    // console.log("paylaterTotalAmount :- ", paylaterTotalAmount);
    // console.log("totalAmount :- ", totalAmount);

    // Push continue button
    if (allValid) {
      let continueText = LocaleStrings.kContinueText;
      if (
        (totalNavs === 3 && currentStep === "assignment") ||
        (totalNavs === 4 && currentStep === "session")
      ) {
        continueText = LocaleStrings.kSaveCheckoutText;
      }

      if (currentStep === "payment") {
        returnHtml.push(
          <div key={`pay_amount_button`} className="pt-5">
            {totalAmount > 0 ? (
              <>
                {callFrom === "admin" ? (
                  <div className="flex items-center space-x-1">
                    <button
                      type="button"
                      className="theme-button-md basis-3/5"
                      onClick={() => handleTicketOrder(totalAmount, "cash")}
                      disabled={pristine || invalid || submitting || btnLoading}
                    >
                      <svg
                        className={classNames(
                          btnLoading && orderAction === "cash" ? "" : "hidden",
                          "cust-btn-spinner"
                        )}
                        viewBox="0 0 1024 1024"
                        focusable="false"
                        data-icon="btnloading"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                      </svg>{" "}
                      {_.replace(
                        LocaleStrings.kPayCashText,
                        "#amount",
                        `${selectedCurrency} ${priceDisplayLocally(
                          totalAmount
                        )}`
                      )}
                    </button>

                    <button
                      type="button"
                      className="theme-button-md basis-2/5"
                      onClick={() =>
                        handleTicketOrder(totalAmount, "withoutpay")
                      }
                      disabled={pristine || invalid || submitting || btnLoading}
                    >
                      <svg
                        className={classNames(
                          btnLoading && orderAction === "withoutpay"
                            ? ""
                            : "hidden",
                          "cust-btn-spinner"
                        )}
                        viewBox="0 0 1024 1024"
                        focusable="false"
                        data-icon="btnloading"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                      </svg>{" "}
                      {LocaleStrings.kPayWithoutpayText}
                    </button>
                  </div>
                ) : (
                  <>
                    {onlinePaymentKeys?.gateway &&
                    stripeConnection?.data?.stripeaccountid ? (
                      <>
                        {onlinePaymentKeys?.gateway === "paypal" ? (
                          <Paypal
                            onlinePaymentKeys={onlinePaymentKeys}
                            paypalAccountId={
                              stripeConnection?.data?.stripeaccountid
                            }
                            amount={totalAmount}
                            currency={selectedCurrency}
                            otherprops={otherprops}
                          />
                        ) : onlinePaymentKeys?.gateway === "razorpay" ? (
                          <Razorpay
                            onlinePaymentKeys={onlinePaymentKeys}
                            paypalAccountId={
                              stripeConnection?.data?.stripeaccountid
                            }
                            amount={totalAmount}
                            currency={selectedCurrency}
                            otherprops={otherprops}
                            buyerinfo={formValues}
                          />
                        ) : (
                          <Stripe
                            onlinePaymentKeys={onlinePaymentKeys}
                            stripeAccountId={
                              stripeConnection?.data?.stripeaccountid
                            }
                            amount={totalAmount}
                            currency={selectedCurrency}
                            otherprops={otherprops}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {showOptions === "offline" ? (
                          <button
                            type="button"
                            className="theme-button-md w-full"
                            onClick={() =>
                              handleTicketOrder(paylaterTotalAmount, "paylater")
                            }
                            disabled={
                              pristine || invalid || submitting || btnLoading
                            }
                          >
                            <svg
                              className={classNames(
                                btnLoading ? "" : "hidden",
                                "cust-btn-spinner"
                              )}
                              viewBox="0 0 1024 1024"
                              focusable="false"
                              data-icon="btnloading"
                              width="1em"
                              height="1em"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                            </svg>{" "}
                            {_.replace(
                              LocaleStrings.kPayLaterText,
                              "#amount",
                              `${selectedCurrency} ${priceDisplayLocally(
                                paylaterTotalAmount
                              )}`
                            )}
                          </button>
                        ) : showOptions === "online" ? (
                          <button
                            type="button"
                            className="theme-button-md w-full"
                            onClick={() =>
                              handleTicketOrder(totalAmount, "payment_intent")
                            }
                            disabled={
                              pristine || invalid || submitting || btnLoading
                            }
                          >
                            <svg
                              className={classNames(
                                btnLoading ? "" : "hidden",
                                "cust-btn-spinner"
                              )}
                              viewBox="0 0 1024 1024"
                              focusable="false"
                              data-icon="btnloading"
                              width="1em"
                              height="1em"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                            </svg>{" "}
                            {_.replace(
                              LocaleStrings.kPlaceOrderAmountText,
                              "###AMOUNT###",
                              `${selectedCurrency} ${priceDisplayLocally(
                                totalAmount
                              )}`
                            )}
                          </button>
                        ) : (
                          <div className="flex items-center space-x-1">
                            {stripeConnection?.data?.stripeaccountid && (
                              <button
                                type="button"
                                className="theme-button-md flex-grow"
                                onClick={() =>
                                  handleTicketOrder(
                                    totalAmount,
                                    "payment_intent"
                                  )
                                }
                                disabled={
                                  pristine ||
                                  invalid ||
                                  submitting ||
                                  btnLoading
                                }
                              >
                                <svg
                                  className={classNames(
                                    btnLoading &&
                                      orderAction === "payment_intent"
                                      ? ""
                                      : "hidden",
                                    "cust-btn-spinner"
                                  )}
                                  viewBox="0 0 1024 1024"
                                  focusable="false"
                                  data-icon="btnloading"
                                  width="1em"
                                  height="1em"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                                </svg>{" "}
                                {_.replace(
                                  LocaleStrings.kPlaceOrderAmountText,
                                  "###AMOUNT###",
                                  `${selectedCurrency} ${priceDisplayLocally(
                                    totalAmount
                                  )}`
                                )}
                              </button>
                            )}

                            <button
                              type="button"
                              className="theme-button-md flex-grow"
                              onClick={() =>
                                handleTicketOrder(
                                  paylaterTotalAmount,
                                  "paylater"
                                )
                              }
                              disabled={
                                pristine || invalid || submitting || btnLoading
                              }
                            >
                              <svg
                                className={classNames(
                                  btnLoading && orderAction === "paylater"
                                    ? ""
                                    : "hidden",
                                  "cust-btn-spinner"
                                )}
                                viewBox="0 0 1024 1024"
                                focusable="false"
                                data-icon="btnloading"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                              </svg>{" "}
                              {_.replace(
                                LocaleStrings.kPayLaterText,
                                "#amount",
                                `${selectedCurrency} ${priceDisplayLocally(
                                  paylaterTotalAmount
                                )}`
                              )}
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <button
                type="button"
                className="theme-button-md w-full"
                onClick={() => handleTicketOrder(totalAmount, "freepayment")}
                disabled={pristine || invalid || submitting || btnLoading}
              >
                <svg
                  className={classNames(
                    btnLoading ? "" : "hidden",
                    "cust-btn-spinner"
                  )}
                  viewBox="0 0 1024 1024"
                  focusable="false"
                  data-icon="btnloading"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                </svg>{" "}
                {LocaleStrings.kPlaceOrder}
              </button>
            )}
          </div>
        );
      } else {
        returnHtml.push(
          // <Razorpay />
          <div key={`continue_button`} className="pt-5">
            <button
              type="button"
              className="theme-button-md w-full"
              onClick={handleContinue}
              disabled={
                totalNavs === 4 &&
                currentStep === "session" &&
                props.disableButton
              }
            >
              {continueText}
            </button>
          </div>
        );
      }
    }

    return returnHtml;
  };

  const renderAvailablePromo = (promoParams) => {
    let context = promoParams?.context ?? ""; // This controls the context of the promo code section, (beforeticket / afterticket) selection
    let promoApplyCode = promoParams?.promoApplyCode ?? "";
    let displayPrePromo = !_.isEmpty(promodata) ?? false; // This controls the display of the pre promo code section
    let discountAppliedTicketNames =
      promoParams?.discountAppliedTicketNames ?? [];

    return (
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-3 my-4">
        {displayPrePromo ? (
          <h3 className="custom-text-primary-sm-bold mb-2">
            {LocaleStrings.kAvailablePromoText}
          </h3>
        ) : (
          ""
        )}

        {_.isEmpty(promoApplied) ? (
          <div className="space-y-4">
            {displayPrePromo ? (
              <div className="flex items-center justify-between bg-white border border-dashed border-theme border-blue-300 rounded-lg p-2 ">
                <div className="custom-text-primary-md-medium">
                  {promodata?.promocode}
                </div>

                {/* Apply action button and display the apply button only in payment section and payment not initiated */}
                {context === "afterticket" &&
                !onlinePaymentKeys?.gateway &&
                ((promodata?.accesstospecificbuyer &&
                  validateEmail(formValues?.email?.trim() ?? "")) ||
                  !promodata?.accesstospecificbuyer) ? (
                  <button
                    type="button"
                    className={classNames(
                      "custom-text-theme-sm-medium hover:underline",
                      applyPrePromo
                        ? "opacity-60 cursor-not-allowed"
                        : "cursor-pointer"
                    )}
                    onClick={applyPrePromo ? null : () => handlePerPromo()}
                  >
                    {LocaleStrings.kApplyText}
                  </button>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}

            <div className="">
              {context === "beforeticket" ? (
                <div className="text-sm font-medium text-blue-900">
                  {promodata?.accesstospecificbuyer
                    ? LocaleStrings.kPrePromoSpecificBuyerAccessInfoText
                    : LocaleStrings.kPrePromoInfoText}
                </div>
              ) : (
                <>
                  {allowPromo ? (
                    <div className="flex items-center space-x-1">
                      <input
                        type="text"
                        name="promocode"
                        className="input-field"
                        placeholder={LocaleStrings.kPlaceholderpromocode}
                        ref={promoRef}
                        disabled={promoButtonLoading}
                      />
                      <button
                        type="button"
                        className="theme-button-outer-md"
                        onClick={() => handlePromoApply()}
                        disabled={promoButtonLoading}
                      >
                        <svg
                          className={classNames(
                            promoButtonLoading ? "" : "hidden",
                            "cust-btn-spinner"
                          )}
                          viewBox="0 0 1024 1024"
                          focusable="false"
                          data-icon="btnloading"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                        </svg>{" "}
                        {LocaleStrings.kApplyText}
                      </button>
                      <button
                        type="button"
                        className="danger-button-outer-md"
                        onClick={() => {
                          setAllowPromo(false);
                          setPromoErrorMessage("");
                        }}
                      >
                        {LocaleStrings.kCancel}
                      </button>
                    </div>
                  ) : (
                    <div
                      className={classNames(
                        "custom-text-theme-sm-bold",
                        onlinePaymentKeys?.gateway
                          ? "cursor-not-allowed"
                          : "cursor-pointer hover:underline"
                      )}
                      onClick={
                        onlinePaymentKeys?.gateway
                          ? null
                          : () => {
                              setAllowPromo(true);
                              setPromoErrorMessage("");
                            }
                      }
                    >
                      {LocaleStrings.kPromocodeText}
                    </div>
                  )}

                  {displayPrePromo ? (
                    <>
                      {promodata?.accesstospecificbuyer &&
                      !validateEmail(formValues?.email?.trim() ?? "") ? (
                        <div className="pt-3 text-sm font-medium text-blue-900">
                          {LocaleStrings.kPrePromoSpecificBuyerAccessInfoText}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>

            {promoErrorMessage !== "" ? (
              <div className="custom-text-danger-md-normal">
                {promoErrorMessage}
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-green-100 text-green-800">
                {promoApplyCode}
              </div>
              <button
                type="button"
                className={`lowercase- text-sm font-medium cursor-pointer text-red-500 hover:text-red-600 ${
                  onlinePaymentKeys?.gateway ? "hidden" : ""
                }`}
                onClick={
                  onlinePaymentKeys?.gateway ? null : () => removePromo()
                }
              >
                {LocaleStrings.kRemoveText}
              </button>
            </div>
            <div className="text-sm text-green-700">
              <div className="mb-1">
                {_.replace(LocaleStrings.kPromoTicketsText, "#ticketname", ``)}
              </div>
              <ul className="ml-4 space-y-1">
                {_.map(discountAppliedTicketNames, (ea, i) => (
                  <li
                    key={`discount_ticket_key_${i}`}
                    className="flex items-center"
                  >
                    <span className="w-1 h-1 bg-green-600 rounded-full mr-2 flex-shrink-0"></span>
                    <span className="font-medium">
                      {ea?.ticketname} * {ea?.quantity}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-col space-y-3">
      {manageTicketsCount?.length > 0
        ? renderTicketsOrder()
        : !_.isEmpty(promodata)
        ? renderAvailablePromo({ context: "beforeticket" })
        : ""}
    </div>
  );
};

const mapStateToProps = (state) => {
  let promodata = state?.ticketLists?.promodata ?? {};
  const formState = state.form;
  let hasAnyError = false;

  Object.keys(formState).forEach((formName) => {
    if (formName.startsWith("SessionAssignForm")) {
      const errors = getFormSyncErrors(formName)(state);
      if (errors && Object.keys(errors).length > 0) {
        hasAnyError = true;
      }
    }
  });

  return {
    session: state.session,
    eventData: state.eventData,
    ticketArray: state.ticketLists,
    eventSettingsData: state.eventSettingsData,
    manageTicketsCount: state.manageTicketsCount,
    promoApplied: state.promoApplied,
    stripeConnection: state.stripeConnection,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
    assignedAttendeeErrors: state.assignedAttendeeErrors,
    promodata,
    promoAppliedRemoved: state?.promoAppliedRemoved?.removed ?? false,
    disableButton: hasAnyError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { manageTicketCount, applyPromo, cancelPromo },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketOrderDetails);
